import { cn } from "@/lib/utils";

interface ConfettiElementProps {
  type: "rectangle" | "diamond" | "oval";
  color: "confetti-blue" | "confetti-green" | "confetti-yellow" | "confetti-light-blue";
  className?: string;
}

export const ConfettiElement = ({ type, color, className }: ConfettiElementProps) => {
  const getShapeClasses = () => {
    switch (type) {
      case "rectangle":
        return "rounded-sm";
      case "diamond":
        return "rotate-45 rounded-sm";
      case "oval":
        return "rounded-full";
      default:
        return "rounded-sm";
    }
  };

  const getColorClasses = () => {
    switch (color) {
      case "confetti-blue":
        return "bg-confetti-blue";
      case "confetti-green":
        return "bg-confetti-green";
      case "confetti-yellow":
        return "bg-confetti-yellow";
      case "confetti-light-blue":
        return "bg-confetti-light-blue";
      default:
        return "bg-confetti-blue";
    }
  };

  return (
    <div 
      className={cn(
        getShapeClasses(),
        getColorClasses(),
        className
      )}
    />
  );
};